import { AxiosError } from 'axios';

import type {
  ImportRuleT,
  ImportTemplateT,
} from '@/features/Setting/Integrations/providers/types';

export const processImportRuleParam = (
  importRule: ImportRuleT,
  template: ImportTemplateT,
) => {
  if (importRule.tag == template.tag.all[0]) {
    return { ...importRule, tag_names: undefined };
  }

  return importRule;
};

export const connectionErrorHandler = (e: unknown): string => {
  if (e instanceof AxiosError) {
    // Error handling rules:
    // If 'status' key is in response result:
    //   1. Status === 409 when the channel identified by given key and secret already exists
    //   2. Status === 403 when given key and secret are invalid
    if (e.response) {
      if (e.response.status === 409) {
        return 'The channel with the access key is already connected to Syncly. Please check again!';
      } else if (e.response.status === 403) {
        return 'Your access key and secret is invalid. Please check again!';
      }
    }
  }
  return 'Unknown Error';
};
